import { uiManager } from '../EntryMobile.ts';
import { UIMSceneEnum } from '../../../../shared/enums/UIMSceneEnums.ts';
import { showSimpleDialog } from '../../../shared/scripts/ui_popup/showSimpleDialog.ts';
export function showPageNavigationWarning(onConfirm) {
    var _uiManager_mainpageController_sceneController, _uiManager_mainpageController;
    const isInGame = (uiManager === null || uiManager === void 0 ? void 0 : (_uiManager_mainpageController = uiManager.mainpageController) === null || _uiManager_mainpageController === void 0 ? void 0 : (_uiManager_mainpageController_sceneController = _uiManager_mainpageController.sceneController) === null || _uiManager_mainpageController_sceneController === void 0 ? void 0 : _uiManager_mainpageController_sceneController.scene) == UIMSceneEnum.Game;
    if (!isInGame) {
        onConfirm();
        return;
    }
    showSimpleDialog({
        title: {
            key: 'strings:game.leaveGame.title'
        },
        body: {
            key: 'strings:game.leaveGame.navigationWarning'
        },
        onConfirm: onConfirm,
        showCancelBtn: true
    });
}
